import React, { Component, Suspense } from 'react'
import { Row, Col, Nav, Card, CardGroup, ListGroup, Image, Tab, Form, Button, Container } from 'react-bootstrap';
import Select from 'react-select';
import { components } from 'react-select'
import SelectDropDown from '../selectdropdown/SelectDropDown'
import ExamDataTable from './ExamDataTable';
import ErrorSkippedTable from './ErrorSkippedTable';
import QuestionTypeDataTable from './QuestionTypeDataTable';
import TimeManagementDataTable from './TimeManagementDataTable';
import TheoryDataTable from './TheoryDataTable';
import ExamStudentData from './ExamStudentData';
import ErrorSkippedModalSection from "./ErrorSkippedModalSection";
import './_home.scss'
import DateBlock from './DateBlock';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter, Link } from "react-router-dom";
import MultiSelect from "react-multi-select-component";
import moment from "moment";
import Absent from '../../../images/absent.png'
import Attended from '../../../images/attended.png'
import AverageScore from '../../../images/averagescore.png'
import Duration from '../../../images/duration.png'
import BotanyAvg from '../../../images/botanyavg.png'
import ZoologyAvg from '../../../images/zoologyavg.png'
import PhysicsAvg from '../../../images/physicsavg.png'
import ChemistryAvg from '../../../images/chemistryavg.png'
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import PreloaderTwo from '../../../student_module/components/preloader/PreloaderTwo';
import SingleStudentDataModal from '../quiz_section/quiz_summary/singelStudentDataModal';
import TotalStudentDataModal from '../quiz_section/quiz_summary/totalStudentDataModal';
import parse, { domToReact } from 'html-react-parser';
import PerformanceAnalysisModal from './performanceAnalysisModal';
import PerformanceAnalysisModalEamcet from './performanceanalysisModalEamcet';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


import SingleStudentProctoringModal from './SingleStudentProctoringModal';

const StudentScoreRangeChart = React.lazy(() => import('./StudentScoreRangeChart'));
const ProctoringTypeChart = React.lazy(() => import('./ProctoringTypeChart'));

const FETCH_PROCTORING_EXAMS = gql`
query($institution_id: Int!, $exam_id: Int) {
  getProctoringExams(institution_id: $institution_id, exam_id: $exam_id){
    mobile
    exam_name
    proctoring_type_id
    exam_paper_id
    inserted_at
    estatus
  }
}
`;

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const SelectExam = [
    { value: 1, label: 'Full Exams' },
    // { value: 2, label: 'Quiz Exams' }
];

const SelectSection = [
    { value: 1, label: 'Select Section' },
    // { value: 2, label: 'Quiz Exams' }
];

const MPC_Subjects = [
    { value: 0, label: "All" },
    { value: 4, label: "Maths" },
    { value: 2, label: "Physics" },
    { value: 3, label: "Chemistry" },
];

const BIPC_Subjects = [
    { value: 0, label: "All" },
    { value: 1, label: "Botany" },
    { value: 5, label: "Zoology" },
    { value: 2, label: "Physics" },
    { value: 3, label: "Chemistry" },
];

class ExamReportSection extends Component {
    constructor(props) {
        super(props)
        console.log("ExamReportSection - constructor - props:", props);
        console.log("ExamReportSection - constructor - props.globals:", props.globals);
        console.log("ExamReportSection - constructor - props.globals?.exams:", props.globals?.exams);
        this.state = {
            selected: [],
            filtertype: "",
            testNames: [],
            Classes: [],
            class_id: "0",
            class_id_value: "",
            ExamTypes: [],
            exam_name: "0",
            exam_name_value: "",
            esectionValue: [],
            esection: "0",
            QuizExams: [],
            FullExams: [],
            TestTypes: { value: 1, label: 'Full Exams' },
            getStudentTableExamReport: "",
            exam_paper_id: "0",
            exam_value: "",
            showSpinner: "hide",
            proctoringExams: [],
            showProctoringModal: false,
            selectedStudentProctoring: [],
            eexamptypeValue: { value: parseInt(this.props.globals.exams[0].id), label: this.props.globals.exams[0].exam },
            exam_id: parseInt(this.props.globals.exams[0].id),
            getStudentTableData: [],
            loading1: false,
            loading2: false,
            buttonLoading: false,
            exclude_missed: true,
            showReportSection: false,
            exam_type_details: parseInt(this.props.globals.exams[0].id),
            attended: true,
            absent: false,
            examName: "",
            startDateCalender: moment(new Date()).subtract(1, "year").unix(),
            endDateCalender: moment(new Date()).unix(),
            testTypeErrMsg: "",
            testPatternErrMsg: "",
            testNameErrmsg: "",
            classErrMsg: "",
            sectionErrMsg: "",
            attempted_exam: "",
            studentResults: [],
            totalStudentDataShow: false,
            singleStudentDataShow: false,
            mobile: "",
            slno: '',
            subjectValue: { value: 0, label: "All" },
            subject_type: 0,
            performanceAnalysisModal: false,
            performanceAnalysisModalEamcet: false,
            performanceData: '',
            performanceDataEamcet: '',
            rowIndexVal: 0,
            examSections: [],
            sectionValue: []


        }
    }


    performanceFunc(cell, row, rowIndex, formatExtraData) {
        return (<>
            {
                this.state.eexamptypeValue.value == 1 || this.state.eexamptypeValue.value == 2 ?
                    (
                        <a onClick={() => this.singleStudentPerformance(row, rowIndex)}>
                            <p style={{ color: "black" }}>{row["student_name"]}</p>
                        </a>
                    )
                    :
                    (
                        <a onClick={() => this.singleStudentPerformanceEamcet(row, rowIndex)}>
                            <p style={{ color: "black" }}>{row["student_name"]}</p>
                        </a>
                    )
            }

        </>)
    }

    actionFormatterStudentName(row) {
        return (<>
            <a onClick={() => this.singleStudentResult(row)}>
                <p style={{ color: "blue" }}>View Analysis</p>
            </a>
        </>)
    }


    handleViewStudentExamResult = (row) => {
        this.props.history.push({
            pathname: "/student/view_question_answer",
            state: {
                mobile: row?.contact_no,
                sessionid: row?.exam_session_id
            }
        });
    };


    handleSelect = (val) => {
        this.setState({
            attempted_exam: val,
            attended: false,
            absent: false
        })
    }

    handleProctoringModal = (mobile) => {
        const studentProctoring = this.state.proctoringExams.filter(item => item.mobile === mobile);
        this.setState({
            showProctoringModal: true,
            selectedStudentProctoring: studentProctoring
        });
    }

    actionsFormatter(cell, row, rowIndex, formatExtraData) {
        const hasProctoring = this.state.proctoringExams.some(item => item.mobile === row.contact_no);

        return (
            <div className="d-flex justify-content-end align-items-top college-button-css">
                {
                    row.totalData.map((item) => {
                        if (row.student_name == item.student_name) {
                            return (
                                <>
                                    {hasProctoring && (
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Proctoring Data</Tooltip>}>
                                            <i
                                                className="px-3 fas fa-file-alt table_chart_icon cursor-pointer text-primary"
                                                onClick={() => this.handleProctoringModal(row.contact_no)}
                                            />
                                        </OverlayTrigger>
                                    )}

                                    <OverlayTrigger placement="top" overlay={<Tooltip>Download</Tooltip>}>
                                        <a
                                            href={`http://admin.mylearningplus.in/student_analytics/generate.php?examtype=exam&id=${item.exam_session_id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="cursor-pointer"
                                        >
                                            <i className="table_chart_icon px-3 fas fa-download text-dark" />
                                        </a>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={<Tooltip>Exam Results</Tooltip>}>
                                        <i
                                            className="px-3 fas fa-chart-line table_chart_icon cursor-pointer"
                                            onClick={() => this.handleSessionFunction(item)}
                                        />
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={<Tooltip>Q & A</Tooltip>}>
                                        <i
                                            className="px-3 fas fa-question-circle table_chart_icon cursor-pointer"
                                            onClick={() => this.handleViewStudentExamResult(item)}
                                        />
                                    </OverlayTrigger>
                                </>

                            )
                        }
                    })
                }          </div>
        );
    }

    handleSessionFunction = (row) => {
        window.open(`http://student.rizee.in/student/subject/college-single-exam-result/:${row.exam_session_id}/:${row.contact_no}/:schedule_exam`, "_blank")
    }

    selecthandleInputChange = async (ename, evalue) => {

        const name = ename;
        const value = evalue;

        if (name == "exam_type") {
            let eexamptypeData = this.props.globals.exams.find((a) => a.id == value);

            let etesttype1 = [];
            let etesttypevalue1 = [];
            this.props.globals && this.props.globals.TestTypes && this.props.globals.testTypes.map((item) => {
                if (item != undefined) {
                    const newObj = {
                        value: item.id,
                        label: item.type,
                    }
                    etesttypevalue1.push(newObj);
                    etesttype1.push(item.id);
                }
            })
            this.setState({
                eexamptypeValue: {
                    value: parseInt(value),
                    label: eexamptypeData.exam
                },
                exam_id: parseInt(value), exam_type_details: parseInt(value),
                TestTypes: "",
                examName: "",
                class_id_value: "",
                esectionValue: "",
                examSections: [],
                sectionValue: [],
                showReportSection: false,
                subjectValue: { value: 0, label: "All" },


            })
        }

        if (name == "test") {
            let labelval = ""

            if (value == 1) {
                labelval = "Full Exams"
            } else {
                labelval = "Quiz Exams"
            }

            this.setState({
                TestTypes: {
                    value: value,
                    label: labelval
                },
                examName: "",
                class_id_value: "",
                esectionValue: "",
                sectionValue: [],
                subjectValue: { value: 0, label: "All" },
            })
        }

        if (name == "exam_name") {
            this.setState({
                exam_paper_id: value,
                esectionValue: "",
                sectionValue: []
            });
            let esectionData = [];
            if (this.state.TestTypes.value == 1) {
                let data = this.state.FullExams.filter(row => row.value == value);
                esectionData = data[0].examSections.find((a) => a.exam_id == this.state.eexamptypeValue.value);
                let sectionFilterData = data[0].examSections.filter((a) => a.exam_id == this.state.eexamptypeValue.value);

                let classData = this.props.globals.classes.find((a) => a.id == data[0].class_id)
                this.setState({
                    class_id_value: {
                        value: classData.id,
                        label: classData.class
                    }, examName: {
                        label: data[0].label,
                        value: value
                    },
                    examSections: sectionFilterData,
                    sectionValue: sectionFilterData,
                    showReportSection: false,
                    subjectValue: { value: 0, label: "All" },
                })
            } else {
                let data = this.state.QuizExams.filter(row => row.value == value);
                let classData = this.props.globals.classes.find((a) => a.id == data[0].class_id)
                this.setState({
                    class_id_value: {
                        value: classData.id,
                        label: classData.class
                    }, examName: {
                        label: data[0].label,
                        value: value
                    },
                    showReportSection: false,
                    subjectValue: { value: 0, label: "All" },
                })
            }
            this.setState({
                esectionValue: {
                    value: esectionData.value,
                    label: esectionData.label
                },
                showReportSection: false,

                subjectValue: { value: 0, label: "All" },
            });
        }

        if (name == "class") {
            let classData = this.props.globals.classes.find((a) => a.id == value)
            this.setState({
                class_id_value: {
                    value: classData.id,
                    label: classData.class
                },
                showReportSection: false,
                subjectValue: { value: 0, label: "All" },
            })
        }
        this.setState({ [name]: value })
        if (name == "esection") {
            if (value != "0") {
                let esectionData = this.props.globals.globalSections.find((a) => a.id == value);
                this.setState({
                    esectionValue: {
                        value: esectionData.id,
                        label: esectionData.section_name
                    },
                    showReportSection: false,
                    subjectValue: { value: 0, label: "All" },
                });
            }
        }
        // if (name == "subjects") {
        //     let subjectDataValue = this.props.globals.subjects.find((a) => a.id == value)
        //     this.setState({
        //         subjectValue: {
        //             value: subjectDataValue.id,
        //             label: subjectDataValue.subject
        //         }
        //     })
        // }
        if (name == "subjects") {
            if (value == 0) {
                this.setState({
                    subjectValue: { value: value, label: 'All' },
                    subject_type: value
                });
            }
            else if (value == 1) {
                this.setState({
                    subjectValue: { value: value, label: 'Botany' },
                    subject_type: value
                });
            }
            else if (value == 2) {
                this.setState({
                    subjectValue: { value: value, label: 'Physics' },
                    subject_type: value
                });
            }
            else if (value == 3) {
                this.setState({
                    subjectValue: { value: value, label: 'Chemistry' },
                    subject_type: value
                });
            }
            else if (value == 4) {
                this.setState({
                    subjectValue: { value: value, label: 'Maths' },
                    subject_type: value
                });
            }
            else if (value == 5) {
                this.setState({
                    subjectValue: { value: value, label: 'Zoology' },
                    subject_type: value
                });
            }
            else if (value == 66) {
                this.setState({
                    subjectValue: { value: value, label: 'General' },
                    subject_type: value
                });
            }

        }
    }

    handleInputChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        if (value == '1') {
            this.setState({ exclude_missed: true }, () => {
                if (this.state.showReportSection) this.getStudentTableOnly();
            });
        } else {
            this.setState({ exclude_missed: false }, () => {
                if (this.state.showReportSection) this.getStudentTableOnly();
            });
        }
    };

    handleMultipleSelectInputChange = (e, name) => {
        console.log("esectionval", name);

        if (name == "sections") {

            let esectionvalue = Array();
            console.log("eddddd", e);

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const esectionval = e[i];


                    const newObj = {
                        label: esectionval.label,
                        value: esectionval.value
                    }

                    esectionvalue.push(newObj);
                }
                this.setState({
                    sectionValue: esectionvalue,
                    sectionErrMsg: ""
                });
            }
        }
    }

    getexamtypes() {
        let newArray = [];
        this.props.globals.exams.map((item) => {
            if (item != undefined) {
                if (item.id != "5" && this.props.stateData.eexamptype != item.id) {
                    const newObj = {
                        value: item.id,
                        label: item.exam
                    }
                    newArray.push(newObj);
                }
            }
        })
        return newArray;
    }

    // getExamSubjects() {
    //     let examsData = this.props.globals.exams.find((a) => a.id == this.state.eexamptypeValue.value);
    //     let examsubjectData = examsData.exam_subjects;
    //     let subjectOptionsArr = []
    //     for (let i = 0; i <= examsubjectData.length; i++) {
    //         let idata = examsubjectData[i];
    //         if (idata != undefined) {
    //             let subjectData = this.props.globals.subjects.find((a) => a.id == idata.subject_id);
    //             const newobj = {
    //                 value: subjectData.id,
    //                 label: subjectData.subject,
    //             }
    //             subjectOptionsArr.push(newobj)
    //         }
    //     }
    //     return subjectOptionsArr

    // }
    prepareExamData = (full_exams) => {
        let fullExamArr = [];

        full_exams.forEach((item) => {
            let examDate = moment.unix(item.start_time).format("MMMM DD YYYY");
            let examDateFormat = moment.unix(item.start_time).format("MM-DD-YYYY");
            let examDateFormatUnix = moment(examDateFormat, 'MM-DD-YYYY').unix();

            let section_arr = item.section.map((item1) => ({
                value: item1.id,
                label: item1.section_name,
                exam_id: item1.exam_id
            }));

            const newobjfull = {
                value: item.id,
                label: `${item.exam_name} ( ${examDate} )`,
                exam_id: item.exam_type,
                class_id: item.class_id,
                start_time: item.start_time,
                examDateFormat,
                examDateFormatUnix,
                examSections: section_arr,
                sectionValue: section_arr
            };

            fullExamArr.push(newobjfull);
        });

        // ✅ Set state ONCE (important)
        this.setState({
            FullExams: fullExamArr,
            exam_value: fullExamArr[0]
                ? { value: fullExamArr[0].value, label: fullExamArr[0].label }
                : null
        });

        // ✅ Handle navigation state
        if (this.props?.location?.state) {
            const { exam_id, exam_name, exam_type, exam_typeValue, examsglobals } =
                this.props.location.state;

            this.setState(
                {
                    exam_paper_id: exam_id,
                    examName: { value: exam_id, label: exam_name },
                    exam_type,
                    exam_typeValue,
                    examTypeOptions: examsglobals || []
                },
                () => {
                    this.getSummaryDetails();
                }
            );
        }
    };

    componentDidUpdate(prevProps) {
        const prevData = prevProps.getDashBoardExams?.full_exams;
        const currentData = this.props.getDashBoardExams?.full_exams;

        // ✅ Run only when data changes
        if (prevData !== currentData && currentData) {
            this.prepareExamData(currentData);
        }
    }

    // getSections() {
    //     let getArray = [];
    //     for (let i = 0; i <= this.props.globals.globalSections.length; i++) {
    //         let idata = this.props.globals.globalSections[i];
    //         if (idata != undefined) {
    //             const newObj = {
    //                 value: idata.id,
    //                 label: idata.section_name,
    //                 exam_id: idata.exam_id
    //             }
    //             getArray.push(newObj);
    //         }
    //     }
    //     console.log("getArray",getArray);
    //     return getArray;
    // }

    actionFormatterQuestionData(rowData) {
        let questionData = this.state.studentResults.filter((item) => item.question_id == rowData);
        if (questionData[0].qtype == "3" || questionData[0].qtype == "9") {
            let question1 = questionData[0].question.replace(/src="/g, 'src=\\"');
            let question2 = question1.replace(/" \/>/g, '\\" />');
            let question = [];
            try {
                question = JSON.parse(question2);
            }
            catch (err) {
                console.log("MATRIX ERROR:", err.message);
            }

            return (
                <Card as={Card.Body} className="bg-light my-2">
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <h6 className='font-weight-bold'>List-I</h6>
                            <ol className="matrixlistoptions font-weight-bold" type={
                                questionData[0].list1type == "alphabets" ? ("A")
                                    : (questionData[0].list1type == "numbers") ? ("1")
                                        : ("roman")}
                            >
                                {question.map((item) => (
                                    <li>{parse(item.qlist1)}</li>
                                ))}
                            </ol>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <h6 className=' font-weight-bold'>List-II</h6>
                            <ol className="matrixlistoptions font-weight-bold" type={
                                questionData[0].list2type == "alphabets" ? ("A")
                                    : (questionData[0].list2type == "numbers") ? ("1")
                                        : ("roman")}>
                                {question.map((item) => (
                                    <li>{parse(item.qlist2)}</li>
                                ))}
                            </ol>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            )
        }
        else if (questionData[0].qtype == "8") {
            return (
                <Card as={Card.Body} className="bg-light my-2 font-weight-bold float-left">
                    {parse(questionData[0].question)}

                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )
        }
        else if (questionData[0].qtype == "5") {
            return (
                <Card as={Card.Body} className="bg-light my-2 fon-weight-bold">
                    {parse(questionData[0].question)}

                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2 ">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>
                </Card>)
        }
        else {
            return (
                <Card as={Card.Body} className="bg-light my-2 questionData font-weight-bold">
                    {parse(questionData[0].question)}
                    <Row className="my-3">
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )
        }
    }


    singleStudentResult = (row) => {
        this.setState({
            singleStudentDataShow: true,
            mobile: row
        })
    }

    totalStudentResults = (data) => {
        this.setState({
            attempted_exam: "totalStudentResults",
            totalStudentDataShow: true,
            slno: data
        })
    }

    singleStudentPerformance = (row, rowIndex) => {
        this.setState({
            performanceAnalysisModal: true,
            performanceData: row,
            rowIndexVal: rowIndex
        })
    }

    singleStudentPerformanceEamcet = (row, rowIndex) => {
        this.setState({
            performanceAnalysisModalEamcet: true,
            performanceDataEamcet: row,
            rowIndexVal: rowIndex
        })
    }

    getSummaryDetails = async () => {
        this.setState({
            testTypeErrMsg: "",
            testPatternErrMsg: "",
            testNameErrmsg: "",
            classErrMsg: "",
            sectionErrMsg: "",

        })



        if (!this.props?.location?.state?.from === "overall") {
            if (this.state.eexamptypeValue == "") {
                this.setState({ testTypeErrMsg: "Please select Test type" })
                return;
            } else if (this.state.TestTypes == "") {
                this.setState({ testPatternErrMsg: "Please select Test pattern" })
                return;
            } else if (this.state.examName == "") {
                this.setState({ testNameErrmsg: "Please select Exam" })
                return;
            } else if (this.state.class_id_value == "") {
                this.setState({ classErrMsg: "Please select Class" })
                return;

            }
            else if (this.state.sectionValue.length == 0) {
                this.setState({ sectionErrMsg: "Please select Section" })
                return;
            }
        }

        this.setState({ showSpinner: "show", buttonLoading: true });

        try {
            const querySummary = this.props.client.query({
                query: gql`
            query(
                $exam_paper_id : Int!,
                $username : String,
                $section_id : String
            ){
                getStudentTableExamReport( 
                exam_paper_id : $exam_paper_id,
                username : $username,
                section_id : $section_id
                )
                {
                    duration
                    botany_average
                    zoology_average
                    general_average
                    maths_average
                    chemistry_average
                    physics_average
                    absent
                    exam_pattern_id
                    attended
                    average_score
                }
            }
            `,
                variables: {
                    exam_paper_id: parseInt(this.state.exam_paper_id),
                    username: Cookies.get("username"),
                    section_id: this.state.sectionValue.map((item) => item.value).toString() || ""
                },
                fetchPolicy: 'network-only'
            });

            const queryTable = this.props.client.query({
                query: gql`
            query getStudentTableData($params: StudentTableInputInfo){
                getStudentTableData(params:$params)
                {
                    id
                    student_name
                    contact_no
                    exam_id
                    branch_id
                    class_id
                    section_id
                    attended
                    branchName
                    sectionName
                    examName
                    className
                    marks
                    exam_session_id
                    accuracy
                    exam_rank
                    overall_rank
                    overall_avg
                    overall_avg_include_missed
                    profile_pic
                    subjectMarks{
                        subjectId
                        subjectName
                        subjectMarks
                        subjectRank 
                        subjectTotalQuestions
                        subjectRight
                        subjectWrong
                    }
                    estatus
                }
            }
            `,
                variables: {
                    "params": {
                        "exam_paper_id": parseInt(this.state.exam_paper_id),
                        "username": Cookies.get("username"),
                        section_id: this.state.sectionValue.map((item) => item.value).toString() || "",
                        "exclude_missed": this.state.exclude_missed
                    }
                },
                fetchPolicy: 'network-only'
            });

            const queryStudentResults = this.props.client.query({
                query: gql`
    query (
      $exam_paper_id: Int!
      $institution_id: Int!
      $type: String
    ) {
      getStudent_correct_wrong_results(
        exam_paper_id: $exam_paper_id
        type: $type
        institution_id: $institution_id
      ) {
        slno
        question
        option1
        option2
        option3
        option4
        answer
        qtype
        list1type
        list2type
        subject
        question_id
        correct_count
        wrong_count
        unanswered_count
        studentResults {
          name
          attempt_answer
          isCorrect
          mobile
        }
      }
    }
  `,
                variables: {
                    exam_paper_id: Number(this.state.exam_paper_id),
                    institution_id: Number(Cookies.get("institutionid")),
                    type: this.state.attempted_exam || "All",
                },
                operationName: "getStudentResults",
                fetchPolicy: "network-only",
            });

            const queryProctoring = this.props.client.query({
                query: FETCH_PROCTORING_EXAMS,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_id: parseInt(this.state.examName.value)
                },
                fetchPolicy: 'network-only'
            });

            const [result, resultTable, studentResults, proctoringResults] = await Promise.all([querySummary, queryTable, queryStudentResults, queryProctoring]);

            const stateUpdates = { showSpinner: "hide", buttonLoading: false };

            if (result && result.data && result.data.getStudentTableExamReport != undefined) {
                stateUpdates.showReportSection = true;
                stateUpdates.getStudentTableExamReport = result.data.getStudentTableExamReport;
            }

            if (resultTable && resultTable.data && resultTable.data.getStudentTableData != undefined) {
                stateUpdates.getStudentTableData = resultTable.data.getStudentTableData;
            }

            if (studentResults && studentResults.data && studentResults.data.getStudent_correct_wrong_results != undefined) {
                stateUpdates.studentResults = studentResults.data.getStudent_correct_wrong_results;
            }

            if (proctoringResults && proctoringResults.data && proctoringResults.data.getProctoringExams != undefined) {
                stateUpdates.proctoringExams = proctoringResults.data.getProctoringExams;
            }

            this.setState(stateUpdates);
        } catch (err) {
            console.error("Error fetching summary details", err);
            this.setState({ showSpinner: "hide", buttonLoading: false });
        }
    }

    getStudentTableOnly = async () => {
        // Fetch only the student table data and update table-specific loading (loading2)
        this.setState({ loading2: true });
        try {
            const resultTable = await this.props.client.query({
                query: gql`
            query getStudentTableData($params: StudentTableInputInfo){
                getStudentTableData(params:$params)
                {
                    id
                    student_name
                    contact_no
                    exam_id
                    branch_id
                    class_id
                    section_id
                    attended
                    branchName
                    sectionName
                    examName
                    className
                    marks
                    exam_session_id
                    accuracy
                    exam_rank
                    overall_rank
                    overall_avg
                    overall_avg_include_missed
                    profile_pic
                    subjectMarks{
                        subjectId
                        subjectName
                        subjectMarks
                        subjectRank 
                        subjectTotalQuestions
                        subjectRight
                        subjectWrong
                    }
                    estatus
                }
            }
            `,
                variables: {
                    "params": {
                        "exam_paper_id": parseInt(this.state.exam_paper_id),
                        "username": Cookies.get("username"),
                        section_id: this.state.sectionValue.map((item) => item.value).toString(),
                        "exclude_missed": this.state.exclude_missed
                    }
                },
                fetchPolicy: 'network-only'
            });

            if (resultTable && resultTable.data && resultTable.data.getStudentTableData != undefined) {
                this.setState({ getStudentTableData: resultTable.data.getStudentTableData, loading2: false });
            } else {
                this.setState({ loading2: false });
            }
        } catch (err) {
            console.error('Error fetching student table data', err);
            this.setState({ loading2: false });
        }
    }

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Name",
            sort: true,
        },
        {
            dataField: "section",
            text: "section",
        },
        {
            dataField: "class",
            text: "Class",
        },
        {
            dataField: "average",
            text: "Overall Average",
        },
        {
            dataField: "score",
            text: "Score",
            sort: true,
        },
        {
            dataField: "rank",
            text: "Rank",
            sort: true,
        },
    ];

    questionColumns = [
        {
            dataField: "index",
            text: "SLNO",
            sort: true
        },
        {
            dataField: "questionID",
            text: "question",
            formatter: this.actionFormatterQuestionData.bind(this),
        },
        {
            dataField: "correctCount",
            text: "Correct",
            sort: true
        },
        {
            dataField: "wrongCount",
            text: "Wrong",
            sort: true,
        },
        {
            dataField: "unanswered",
            text: "Unanswered",
            sort: true,
        },
        {
            dataField: "slno",
            text: "Results",
        },
    ];

    tablesectionData(data) {
        let returnArray = [];

        data = data.sort(function (x, y) {
            return y.overall_avg - x.overall_avg;
        })
        data.map((item, index) => {
            let newObj = {
                totalData: data,
                student_name: item.student_name,
                exam: item.examName,
                //class: item.className,
                section: item.sectionName,
                branch: item.branchName,
                attended: (item.attended) ? "Yes" : "No",
                marks: item.marks,
                accuracy: parseInt(item.accuracy),
                examrank: parseInt(item.exam_rank),
                overallrank: parseInt(item.overall_rank),
                branch_id: item.branch_id,
                class_id: item.class_id,
                section_id: item.section_id,
                overall_rank: (index + 1),
                overall_avg: this.state.exclude_missed ? item.overall_avg : item.overall_avg_include_missed,
                contact_no: item.contact_no,
                estatus: item.estatus
            }
            item.subjectMarks.map((item) => {
                const field2 = item.subjectName;
                const field3 = item.subjectName + "-" + "Rank";
                const newObj1 = {
                    ...newObj,
                    [`${field2}`]: item.subjectMarks,
                    [`${field3}`]: parseInt(item.subjectRank)

                }

                newObj = newObj1;
            });
            returnArray.push(newObj);


        });
        if (this.state.getStudentTableData.length > 0 && this.state.attended) {
            returnArray = returnArray.filter((a) => a.attended == "Yes" && a.estatus == 1);
        } else {
            returnArray = returnArray.filter((a) => a.attended == "No" && a.estatus == 1);
        }
        return returnArray;
    }

    Columns(data) {
        let Columns = [
            {
                dataField: "overall_rank",
                text: "Overall rank",
            },
            {
                dataField: "student_name",
                text: "Student Name ",
                // formatter: this.performanceFunc.bind(this),
            },
            {
                dataField: "overall_avg",
                text: "Overall Average",
            },
            /*{
                dataField: "class",
                text: "Class",
            },*/
            {
                dataField: "section",
                text: "Section",
            },
            {
                dataField: "branch",
                text: "Branch",
            },
            /*{
                dataField: "attended",
                text: "Attended",
                sort: true,
                formatter: this.attendedStatus
            },*/
            {
                dataField: "marks",
                text: "Marks",
                sort: true
            },
            {
                dataField: "accuracy",
                text: "Accuracy",
                sort: true
            },
            {
                dataField: "examrank",
                text: "Exam Rank",
                sort: true
            },

        ];
        if (data.length > 0) {
            data[0].subjectMarks.map((item) => {

                const newObj =
                {
                    dataField: item.subjectName,
                    text: item.subjectName + " " + "Marks",
                    sort: true
                }

                const newObj1 =
                {
                    dataField: item.subjectName + "-" + "Rank",
                    text: item.subjectName + " " + "Rank",
                    sort: true
                }
                Columns.push(newObj);
                Columns.push(newObj1);
            });
        }
        // {
        //     const abc =
        //     {
        //         dataField: "Actions",
        //         text: "Actions",
        //         sort: true,
        //         formatter: this.actionsFormatter.bind(this),
        //         headerAlign: 'center',
        //         align: 'center',
        //     }
        //     Columns.push(abc);
        // }
        if (!this.state.absent) {
            Columns.push({
                dataField: "Actions",
                text: "Actions",
                sort: true,
                formatter: this.actionsFormatter.bind(this),
                headerAlign: "center",
                align: "center",
            });
        }

        // {
        //     const resultsAnalysis =
        //     {
        //         dataField: "contact_no",
        //         text: "View Analysis",
        //         formatter: this.actionFormatterStudentName.bind(this),
        //     }
        //     Columns.push(resultsAnalysis)
        // }
        if (!this.state.absent) {
            Columns.push({
                dataField: "contact_no",
                text: "View Analysis",
                formatter: this.actionFormatterStudentName.bind(this),
            });
        }

        return Columns;

    }


    defaultSorted = [
        {
            dataField: "marks",
            order: "desc"
        },

    ];

    getStatus = () => {
        // const { examName, TestTypes, class_id_value, esectionValue, exam_paper_id } = this.state;
        // if (exam_paper_id > 0 && TestTypes.value && class_id_value.value && esectionValue.value != 0 && examName.value) {

        const { examName, TestTypes, class_id_value, exam_paper_id } = this.state;
        if (exam_paper_id > 0 && TestTypes.value && class_id_value.value && examName.value) {
            return false
        }
        return true
    }

    applyCallback = (startDate, endDate) => {


        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix()
        })
    }

    resultData(resultData) {
        const question_data = Array();
        for (let i = 0; i < resultData.length; i++) {
            question_data.push({
                index: i + 1,
                correctCount: resultData[i].correct_count,
                wrongCount: resultData[i].wrong_count,
                unanswered: resultData[i].unanswered_count,
                questionID: resultData[i].question_id,
                slno: <a onClick={() => this.totalStudentResults(resultData[i].slno)} style={{ color: "blue" }}>View</a>
            });

            question_data.sort(function (a, b) {
                return parseFloat(b.wrongCount) - parseFloat(a.wrongCount);
            })
        }
        return question_data;
    }




    downloadExcel = () => {

        // Extract unique subjects
        let subjects = [...new Set(
            this.state.getStudentTableData.flatMap(item =>
                item.subjectMarks.map(sub => sub.subjectName)
            )
        )];

        // Add TOTAL at the end
        subjects.push("Total");

        // Main merged headers
        const mainHeaders = [
            ...Array(8).fill(null),
            ...subjects.flatMap(subject =>
                subject === "Total"
                    ? [subject, null, null]          // Total → 3 columns
                    : [subject, null, null, null]    // Normal subject → 4 columns
            )
        ];

        // Sub headers
        const subHeaders = [
            "User Name", "Student Name", "Exam Name", "Branch Name", "Section Name",
            "Marks", "Accuracy", "Exam Rank",
            ...subjects.flatMap(subject =>
                subject === "Total"
                    ? ["Correct", "Wrong", "Unanswered"]         // Total = 3 cols
                    : ["Correct", "Wrong", "Unanswered", "Marks"] // Normal = 4 cols
            )
        ];

        // Rows
        const rows = this.state.getStudentTableData
            .sort((a, b) => b.marks - a.marks)
            .map(item => {

                const staticData = [
                    item.contact_no,
                    item.student_name,
                    item.examName,
                    item.branchName,
                    item.sectionName,
                    item.marks,
                    item.accuracy,
                    item.exam_rank
                ];

                const dynamicData = subjects.flatMap(subject => {

                    // TOTAL subject logic (NO MARKS)
                    if (subject === "Total") {
                        let right = 0, wrong = 0, totalQ = 0;

                        item.subjectMarks.forEach(s => {
                            right += s.subjectRight || 0;
                            wrong += s.subjectWrong || 0;
                            totalQ += s.subjectTotalQuestions || 0;
                        });

                        const unanswered = totalQ - (right + wrong);

                        return [right, wrong, unanswered]; // 3 columns
                    }

                    // Normal subject
                    const subj = item.subjectMarks.find(s => s.subjectName === subject) || {};

                    const right = subj.subjectRight || 0;
                    const wrong = subj.subjectWrong || 0;
                    const totalQ = subj.subjectTotalQuestions || 0;
                    const unanswered = totalQ - (right + wrong);
                    const marks = subj.subjectMarks || 0;

                    return [right, wrong, unanswered, marks];
                });

                return [...staticData, ...dynamicData];
            });

        const worksheetData = [mainHeaders, subHeaders, ...rows];

        // Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Merge subject headers
        const merges = [];
        let colIndex = 8;

        for (let i = 0; i < subjects.length; i++) {
            const isTotal = subjects[i] === "Total";

            merges.push({
                s: { r: 0, c: colIndex },
                e: { r: 0, c: colIndex + (isTotal ? 2 : 3) } // Total = 3 columns, normal = 4
            });

            colIndex += isTotal ? 3 : 4;
        }

        worksheet["!merges"] = merges;

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Student Report");

        // Download file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "student-report.xlsx");
    };


    // console.log("stateee",this.state);


    render() {
        console.log("ExamReportSection - Received props:", this.props);
        console.log("ExamReportSection - globals prop:", this.props.globals);
        console.log("ExamReportSection - globals.exams:", this.props.globals?.exams);
        console.log("getDashBoardExams", this.props.getDashBoardExams)
        console.log("getStudentTableData", this.state)
        let row = { row: { "totaldata": 9, Arr: ["1"] }, rowIndex: 1 }

        // console.log("ttt", this.state)

        const { loading1, loading2 } = this.state;
        let classnewArray = [];
        this.props.globals.classes.map((item) => {
            if (item != undefined) {
                const newObj = {
                    value: item.id,
                    label: item.class
                }
                classnewArray.push(newObj);
            }
        })

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;
        if (classnewArray.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "No Options"
        }

        let sectionnewArray = [];
        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        if (this.state.examSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectionselectall = false;
            sectionlabelledBy = "No Options";
            sectiondisableSearch = true;
        }


        let tabledata = [];

        let subjectWiseData = [];
        let filterData = this.state.studentResults

        if (this.state.subjectValue.value == 0) {
            subjectWiseData = filterData
        } else {
            subjectWiseData = this.state.studentResults.filter((item) => item.subject == this.state.subjectValue.value)
        }


        // if (loading1 == true) {
        //     // summary-level loading: show full preloader
        //     return (<PreloaderTwo />)
        // }

        console.log(this.props?.location?.state?.exam_id, "ewlfhwepifwpye")
        return (
            <div className="home_section mt-4">
                {loading1 ? <div className="text-center my-4 h-100vh"><PreloaderTwo /></div> :
                    <Container fluid>
                        <Row>
                            <Col xl={12} lg={12} md={12} sm={12}>
                                <Card as={Card.Body}>
                                    <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                        <h2 className="title h5 mb-0">View Test Results</h2>
                                        {/* <Button className='btn btn-primary btn-light-blue float-right mt-4' onClick={() => this.downloadExcel()}><i class="fa fa-cloud-download"></i> Download Report</Button> */}

                                        <div className="filter-block d-flex align-items-center mr-4">
                                            <Form.Group className="customDate mb-0 mr-2" controlId="StartDate" style={{ width: 180 }}>
                                                <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end}
                                                    stateData={this.props.stateData}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <Card className="filter my-3 p-3">
                                        <Form>
                                            <Row>
                                                <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId='selectExam'>
                                                    <Form.Label className="text-uppercase font-weight-bold mt-2">Test Type <span className='errorCls'>{this.state.testTypeErrMsg}</span></Form.Label>

                                                    <Form.Label className="text-uppercase font-weight-bold"></Form.Label>
                                                    <SelectDropDown className="dropdown"
                                                        name="exam_type"
                                                        placeholderName={'Test Type'}
                                                        dropdownIndicator={{ DropdownIndicator }}
                                                        options={this.getexamtypes()}
                                                        handleChange={this.selecthandleInputChange}
                                                        stateData={this.state.eexamptypeValue}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId='selectExam'>
                                                    <Form.Label className="text-uppercase font-weight-bold mt-2">Test Pattern <span className='errorCls'>{this.state.testPatternErrMsg}</span></Form.Label>

                                                    <Form.Label className="text-uppercase font-weight-bold"></Form.Label>
                                                    <SelectDropDown
                                                        name="test"
                                                        placeholderName={'Test Pattern'}
                                                        dropdownIndicator={{ DropdownIndicator }}
                                                        options={SelectExam}
                                                        handleChange={this.selecthandleInputChange}
                                                        stateData={this.state.TestTypes}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId='selectExam'>
                                                    <Form.Label className="text-uppercase font-weight-bold mt-2">Test Name <span className='errorCls'>{this.state.testNameErrmsg}</span></Form.Label>

                                                    <Form.Label className="text-uppercase font-weight-bold"></Form.Label>
                                                    <SelectDropDown
                                                        name="exam_name"
                                                        placeholderName={'Test Name'}
                                                        dropdownIndicator={{ DropdownIndicator }}
                                                        // options={(this.state.TestTypes.value == 1) ? this.state.FullExams.filter(row => row.exam_id == this.state.exam_id && ((this.state.startDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix >= this.state.startDateCalender)) && (this.state.endDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix <= this.state.endDateCalender)))) : this.state.QuizExams.filter(row => row.exam_id == this.state.exam_id && ((this.state.startDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix >= this.state.startDateCalender)) || (this.state.endDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix <= this.state.endDateCalender))))}
                                                        handleChange={this.selecthandleInputChange}
                                                        options={(this.state.TestTypes.value == 1) ? this.state.FullExams.filter(row => row.exam_id == this.state.exam_id && ((this.state.startDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix >= this.state.startDateCalender)) && (this.state.endDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix <= this.state.endDateCalender)))) : this.state.QuizExams.filter(row => row.exam_id == this.state.exam_id && ((this.state.startDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix >= this.state.startDateCalender)) && (this.state.endDateCalender != 0 && (this.state.startDateCalender == this.state.endDateCalender || row.examDateFormatUnix <= this.state.endDateCalender))))}
                                                        stateData={this.state.examName}
                                                    />
                                                </Form.Group>
                                                {/* <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId='selectExam'>
                                                <Form.Label className="text-uppercase font-weight-bold ">Class<span className='errorCls'>{this.state.classErrMsg}</span></Form.Label>

                                                <Form.Label className="text-uppercase font-weight-bold"></Form.Label>
                                                <SelectDropDown
                                                    name="class"
                                                    placeholderName={'Select Class'}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                    options={classnewArray}
                                                    handleChange={this.selecthandleInputChange}
                                                    stateData={this.state.class_id_value}

                                                />
                                            </Form.Group> */}


                                                {/* <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId='selectExam'>
                                                <Form.Label className="text-uppercase font-weight-bold">Section <span className='errorCls'>{this.state.sectionErrMsg}</span></Form.Label>

                                                <Form.Label className="text-uppercase font-weight-bold"></Form.Label>
                                                <SelectDropDown className="dropdown"
                                                    name="esection"
                                                    placeholderName={'Section'}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                    options={this.state.examSections.length == 0 ? SelectSection : this.state.examSections.filter(row => row.exam_id == this.state.exam_id)}
                                                    handleChange={this.selecthandleInputChange}
                                                    stateData={this.state.esectionValue}

                                                />
                                            </Form.Group> */}



                                                <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectSection"  >
                                                    <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                                    <MultiSelect
                                                        overrideStrings={{
                                                            "allItemsAreSelected": "All Sections are selected.",
                                                            "selectSomeItems": sectionlabelledBy
                                                        }
                                                        }
                                                        disableSearch={sectiondisableSearch}
                                                        hasSelectAll={sectionselectall}
                                                        options={this.state.examSections}
                                                        value={this.state.sectionValue}
                                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "sections")}
                                                        labelledBy={"Sections"}
                                                    />
                                                    <Form.Text className="form-text text-danger">
                                                        {this.state.sectionErrMsg}
                                                    </Form.Text>
                                                </Form.Group>




                                                <Form.Group as={Col} xl={4} lg={4} md={6} sm={12}>
                                                    <Button type="button" className='dash_button float-right mt-4' disabled={this.getStatus() || this.state.buttonLoading} onClick={(e) => this.getSummaryDetails()}>
                                                        {this.state.buttonLoading ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                                Loading
                                                            </>
                                                        ) : (
                                                            'Get Report'
                                                        )}
                                                    </Button>
                                                </Form.Group>
                                            </Row>
                                        </Form>
                                    </Card>
                                    {(this.state.showReportSection) ? (
                                        <Row>
                                            <Col>
                                                <div className='exam_report_section'>
                                                    <h5 className='report_header p-3'>Exam Report</h5>
                                                    <Container fluid>
                                                        <Row className='d-flex justify-content-center'>
                                                            <Col sm={3}>
                                                                <Card className='each_card br_yellow'>
                                                                    <Card.Body className="p-2">
                                                                        <Row>
                                                                            <Col sm={9}>
                                                                                <Card.Title className='header mt-1'>Duration (Mins)</Card.Title>
                                                                            </Col>
                                                                            <Col sm={3}>
                                                                                <Card.Img src={Duration} className='dashboard_logo' />
                                                                            </Col>
                                                                        </Row>
                                                                        <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.duration}</Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Card className='each_card br_green'>
                                                                    <Card.Body className="p-2">
                                                                        <Row>
                                                                            <Col sm={9}>
                                                                                <Card.Title className='header mt-1'>Attended</Card.Title>
                                                                            </Col>
                                                                            <Col sm={3}>
                                                                                <Card.Img src={Attended} className='dashboard_logo' />
                                                                            </Col>
                                                                        </Row>
                                                                        <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.attended}</Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Card className='each_card'>
                                                                    <Card.Body className="p-2">
                                                                        <Row>
                                                                            <Col sm={9}>
                                                                                <Card.Title className='header mt-1'>Absent</Card.Title>
                                                                            </Col>
                                                                            <Col sm={3}>
                                                                                <Card.Img src={Absent} className='dashboard_logo' />
                                                                            </Col>
                                                                        </Row>
                                                                        <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.absent}</Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Card className='each_card br_red'>
                                                                    <Card.Body className="p-2">
                                                                        <Row>
                                                                            <Col sm={9}>
                                                                                <Card.Title className='header mt-1'>Average Score</Card.Title>
                                                                            </Col>
                                                                            <Col sm={3}>
                                                                                <Card.Img src={AverageScore} className='dashboard_logo' />
                                                                            </Col>
                                                                        </Row>
                                                                        <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.average_score}</Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        </Row>

                                                        <Row className='mt-4'>
                                                            {
                                                                this.state.getStudentTableExamReport.exam_pattern_id != 90 ? (
                                                                    <>
                                                                        {(this.state.exam_type_details == 1 || this.state.exam_type_details == 7 || this.state.exam_type_details == 8) ? (<><Col sm={3}>
                                                                            <Card className='each_card br_orange'>
                                                                                <Card.Body className="p-2">
                                                                                    <Row>
                                                                                        <Col sm={9}>
                                                                                            <Card.Title className='header mt-1'>Botany (Avg)</Card.Title>
                                                                                        </Col>
                                                                                        <Col sm={3}>
                                                                                            <Card.Img src={BotanyAvg} className='dashboard_logo' />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.botany_average}</Card.Text>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </Col>
                                                                            <Col sm={3}>
                                                                                <Card className='each_card br_yellow'>
                                                                                    <Card.Body className="p-2">
                                                                                        <Row>
                                                                                            <Col sm={9}>
                                                                                                <Card.Title className='header mt-1'>Zoology (Avg)</Card.Title>
                                                                                            </Col>
                                                                                            <Col sm={3}>
                                                                                                <Card.Img src={ZoologyAvg} className='dashboard_logo' />
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.zoology_average}</Card.Text>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col></>) : (<Col sm={3}>
                                                                                <Card className='each_card br_yellow'>
                                                                                    <Card.Body className="p-2">
                                                                                        <Row>
                                                                                            <Col sm={9}>
                                                                                                <Card.Title className='header mt-1'>Maths (Avg)</Card.Title>
                                                                                            </Col>
                                                                                            <Col sm={3}>
                                                                                                <Card.Img src={ZoologyAvg} className='dashboard_logo' />
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.maths_average}</Card.Text>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>)}
                                                                        <Col sm={3}>
                                                                            <Card className='each_card br_green'>
                                                                                <Card.Body className="p-2">
                                                                                    <Row>
                                                                                        <Col sm={9}>
                                                                                            <Card.Title className='header mt-1'>Physics (Avg)</Card.Title>
                                                                                        </Col>
                                                                                        <Col sm={3}>
                                                                                            <Card.Img src={PhysicsAvg} className='dashboard_logo' />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.physics_average}</Card.Text>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                            <Card className='each_card br_orange'>
                                                                                <Card.Body className="p-2">
                                                                                    <Row>
                                                                                        <Col sm={9}>
                                                                                            <Card.Title className='header mt-1'>Chemistry (Avg)</Card.Title>
                                                                                        </Col>
                                                                                        <Col sm={3}>
                                                                                            <Card.Img src={ChemistryAvg} className='dashboard_logo' />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.chemistry_average}</Card.Text>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </Col>
                                                                    </>
                                                                ) : (
                                                                    <Col sm={3}>
                                                                        <Card className='each_card br_orange'>
                                                                            <Card.Body className="p-2">
                                                                                <Row>
                                                                                    <Col sm={9}>
                                                                                        <Card.Title className='header mt-1'>General (Avg)</Card.Title>
                                                                                    </Col>
                                                                                    <Col sm={3}>
                                                                                        <Card.Img src={ChemistryAvg} className='dashboard_logo' />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Card.Text className='description text-center'>{this.state.getStudentTableExamReport.general_average}</Card.Text>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Col>
                                                                )
                                                            }

                                                        </Row>

                                                        <div>
                                                            <Row>
                                                                <Col sm={8}>
                                                                    <h5 className='report_header mt-4'>Students Report - Class : {this.state.class_id_value.label} Details</h5>
                                                                </Col>
                                                                <Col sm={4}>
                                                                    <Button className='btn btn-primary btn-light-blue float-right mt-4' onClick={() => this.downloadExcel()}><i class="fa fa-cloud-download"></i> Download Report</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col sm={4} className="mt-4">
                                                                    <div className="custom-control custom-radio custom-control-inline margin_right0">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude"
                                                                            value="1"
                                                                            name="resultstype"
                                                                            className="custom-control-input"
                                                                            defaultChecked={true}
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <label
                                                                            className="custom-control-label font-weight-normal"
                                                                            htmlFor="exclude"
                                                                        >
                                                                            Exclude Missed Tests
                                                                        </label>
                                                                    </div>
                                                                    <div className="custom-control custom-radio custom-control-inline margin_right0 right_pos">
                                                                        <input
                                                                            type="radio"
                                                                            id="include"
                                                                            value="2"
                                                                            name="resultstype"
                                                                            className="custom-control-input"
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <label
                                                                            className="custom-control-label  font-weight-normal"
                                                                            htmlFor="include"
                                                                        >
                                                                            Include Missed Tests
                                                                        </label>
                                                                    </div>

                                                                </Col>
                                                                <Col sm={6} className="mt-4">
                                                                    <ul className='d-flex justify-content-end sel_cls'>
                                                                        {/* <li className={this.state.attended == true ? "active mr-2" : "mr-4"} onClick={(e) => this.setState({ attended: true, absent: false, attempted_exam: "" })} >Attended</li> */}
                                                                        <li className={this.state.attended ? "active mr-2" : "mr-4"}
                                                                            onClick={() => this.setState({ attended: true, absent: false, attempted_exam: "" })}>
                                                                            Attended
                                                                        </li>
                                                                        {/* <li className={this.state.absent == true ? "active mr-2" : "mr-4"} onClick={(e) => this.setState({ absent: true, attended: false, attempted_exam: "" })}>Absentees</li> */}
                                                                        <li className={this.state.absent ? "active mr-2" : "mr-4"}
                                                                            onClick={() => this.setState({ absent: true, attended: false, attempted_exam: "" })}>
                                                                            Absentees
                                                                        </li>
                                                                        <li className={this.state.attempted_exam == "totalStudentResults" ? "active mr-2" : "mr-4"} onClick={(e) => this.handleSelect("totalStudentResults")}>Result Analysis</li>

                                                                    </ul>
                                                                </Col>
                                                                {/* <Col sm={2} className='mt-4'>
                                                                <SelectDropDown className="dropdown"
                                                                    name="subjects"
                                                                    placeholderName={'subject'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                    // options={this.getExamSubjects()}
                                                                    options={(this.state.exam_type_details == 7 || this.state.exam_type_details == 8 || this.state.exam_type_details == 1) ? BIPC_Subjects : MPC_Subjects}
                                                                    handleChange={this.selecthandleInputChange}
                                                                    stateData={this.state.subjectValue}
                                                                />
                                                            </Col> */}

                                                            </Row>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <Suspense fallback={<div>Loading Proctoring Data...</div>}>
                                                                        <ProctoringTypeChart
                                                                            exam_id={this.state.examName.value}
                                                                            total_students={(parseInt(this.state.getStudentTableExamReport.attended) || 0) + (parseInt(this.state.getStudentTableExamReport.absent) || 0)}
                                                                            absent_count={this.state.getStudentTableExamReport.absent || 0}
                                                                            stateData={this.state}
                                                                        />
                                                                    </Suspense>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    {this.state.loading2 ? (
                                                                        <div className="text-center my-4">
                                                                            <span className="spinner-border" role="status" aria-hidden="true"></span>
                                                                        </div>
                                                                    ) : (
                                                                        <CardLessDataTableWithOutSearch
                                                                            stateData={this.state}
                                                                            parentData={this.state.attempted_exam == "totalStudentResults" ? this.resultData(subjectWiseData) : this.tablesectionData(this.state.getStudentTableData)}
                                                                            particlecolumns={this.state.attempted_exam == "totalStudentResults" ? this.questionColumns : this.Columns(this.state.getStudentTableData)}
                                                                            defaultSorted={this.defaultSorted}
                                                                        />
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </div>

                                                        <TotalStudentDataModal
                                                            show={this.state.totalStudentDataShow}
                                                            onHide={() => this.setState({ totalStudentDataShow: false, slno: '' })}
                                                            data={this.state}
                                                        />
                                                        <SingleStudentDataModal
                                                            show={this.state.singleStudentDataShow}
                                                            onHide={() => this.setState({ singleStudentDataShow: false })}
                                                            stateData={this.state}
                                                        />

                                                        <PerformanceAnalysisModal
                                                            show={this.state.performanceAnalysisModal}
                                                            onHide={() => this.setState({ performanceAnalysisModal: false })}
                                                            data={this.state.performanceData}
                                                            rowIndex={this.state.rowIndexVal}
                                                        />

                                                        <PerformanceAnalysisModalEamcet
                                                            show={this.state.performanceAnalysisModalEamcet}
                                                            onHide={() => this.setState({ performanceAnalysisModalEamcet: false })}
                                                            data={this.state.performanceDataEamcet}
                                                            rowIndex={this.state.rowIndexVal}
                                                            exam_id={this.state.eexamptypeValue.value}
                                                        />

                                                        <SingleStudentProctoringModal
                                                            show={this.state.showProctoringModal}
                                                            onHide={() => this.setState({ showProctoringModal: false })}
                                                            proctoringData={this.state.selectedStudentProctoring}
                                                        />
                                                    </Container>
                                                </div>
                                            </Col>
                                        </Row>) : ('')}



                                </Card>


                            </Col>
                        </Row>
                    </Container>}
            </div>
        )
    }
}

export default withRouter(withApollo(ExamReportSection));
